import { BasicClient } from '@/utils/httpClient'

export default class Company {
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }

  getSectors() {
    return this.client.exec('/v2/admin-mod/sectors', 'GET')
  }

  getLocations() {
    return this.client.exec('/v2/admin-mod/locations', 'GET')
  }

  getSectorAndLocation() {
    return this.client.exec('/v2/admin-mod/user/sectorsAndLocations', 'GET')
  }
  
  getPublicationDateRange (){
    return  this.client.exec('/document-publication/setup', 'GET')
  }
  
  updateLogo(params) {
    return this.client.exec(`/company-management/logo`, 'POST', params, true)
  }

  updateColors(params) {  
    return this.client.exec(`/v2/companies/colors`, 'POST', params)
  }

  sendWelcomeEmail () {
    return  this.client.exec('/v2/companies/welcome-email', 'POST')
  }
}
